import { Product } from 'features/products/types/products.types'
import { useContext, useEffect } from 'react'
import { dataURLtoFile, getBase64FromUrl } from 'features/settings/utils/utils'
import { FieldValues, UseFormReset } from 'react-hook-form'
import { StoreSettingsContext } from 'store'
import { SettingsItem } from 'features/dashboard'

type UsePopulateProductProps = {
	data: Product | undefined
	setValue: (name: string, value: any) => void
	reset: UseFormReset<FieldValues>
}

export const usePopulateProduct = ({ data, setValue, reset }: UsePopulateProductProps) => {
	const storeCtx = useContext(StoreSettingsContext)
	const currentVatRate = storeCtx?.storeSettings?.vat_rate_choices?.find(
		(v: SettingsItem['vat_rate_choices'][number]) => v.value === data?.vat_rate
	)

	useEffect(() => {
		if (data) {
			reset({
				name: data.name,
				quantity: data.quantity,
				price: +data.price.amount,
				cost_price: data.cost_price,
				published: data.published,
				size: data.size,
				supplier_barcode: data.supplier_barcode || '',
				supplier_sku: data.supplier_sku || '',
				...(data?.category
					? {
							category: {
								value: data?.category?.id,
								label: data?.category?.name
							}
						}
					: {}),
				...(data?.product_condition
					? {
							productCondition: {
								value: data?.product_condition?.id,
								label: data?.product_condition?.name
							}
						}
					: {}),
				...(data?.product_fabric
					? {
							productFabricType: {
								value: data?.product_fabric?.id,
								label: data?.product_fabric?.name
							}
						}
					: {}),
				...(data?.product_gender
					? {
							productGender: {
								value: data?.product_gender?.id,
								label: data?.product_gender?.name
							}
						}
					: {}),
				...(data?.product_type
					? {
							productType: {
								value: data?.product_type?.id,
								label: data?.product_type?.name
							}
						}
					: {}),
				...(data?.vat_rate
					? {
							vat_rate: currentVatRate
						}
					: {}),
				...(data?.booking
					? {
							booking: {
								value: data?.booking?.id,
								label: data?.booking?.booth
									? `${data?.booking?.booth?.booth_type?.name} #${data?.booking?.booth?.number}`
									: `${data?.booking?.start_date}`
							}
						}
					: {})
			})

			if (data?.image) {
				fetch(data?.image).then((res) => {
					const name = res.url.split('/').pop()
					getBase64FromUrl(res.url).then((res) => {
						setValue('image', dataURLtoFile(res as string, name!))
					})
				})
			}
		}
	}, [data])
}
